import { create } from 'zustand'
import { IWalletBalance } from 'types/prize-draw/wallet'

// State of a just-completed top-up from the draw page:
// 'adding' - still waiting for it to be credited; 'processing' - gave up waiting while
// the deposit is still pending, so the balance shown is known to be stale.
export type TopUpCreditState = 'idle' | 'adding' | 'processing'

interface WalletState {
  walletBalance: IWalletBalance | null
  freeEntriesTotal: number
  remainingFreeEntries: number
  topUpCreditState: TopUpCreditState
  setWalletBalance: (balance: IWalletBalance | null) => void
  setFreeEntriesTotal: (freeEntriesTotal: number) => void
  setRemainingFreeEntries: (remainingFreeEntries: number) => void
  setTopUpCreditState: (topUpCreditState: TopUpCreditState) => void
}

export const useWalletStore = create<WalletState>((set) => ({
  walletBalance: null,
  freeEntriesTotal: 0,
  remainingFreeEntries: 0,
  topUpCreditState: 'idle',
  setWalletBalance: (walletBalance) => set({ walletBalance }),
  setFreeEntriesTotal: (freeEntriesTotal: number) => set({ freeEntriesTotal }),
  setRemainingFreeEntries: (remainingFreeEntries: number) => set({ remainingFreeEntries }),
  setTopUpCreditState: (topUpCreditState: TopUpCreditState) => set({ topUpCreditState }),
}))
